import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { PUJA, waLink, WA } from "../../data/content";
import { SectionHead } from "./Ornament";
import { WhatsappIcon } from "./Header";
import { EASE } from "../../lib/motion";

export const PujaEssentials = () => {
  const { t } = useLang();
  return (
    <section id="puja" data-testid="puja-section" className="relative bg-cream py-24 sm:py-32 overflow-hidden">
      {/* subtle jaali watermark */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #C59E3F 1.5px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.puja.overline} heading={S.puja.heading} sub={S.puja.sub} />

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-7">
          {PUJA.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`puja-card-${p.id}`}
              className="group text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 4) * 0.08 }}
            >
              <div className="relative overflow-hidden rounded-t-[90px] rounded-b-lg border border-gold/25 aspect-[3/4] bg-ivory">
                <img
                  src={p.img}
                  alt={`${t(p.name)} — puja essential`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
              </div>
              <h3 className="mt-4 font-serif text-lg text-maroon leading-tight">{t(p.name)}</h3>
              <p className="mt-1 text-maroon/55 text-xs leading-relaxed px-2">{t(p.desc)}</p>
              <div className="mt-3 flex items-center justify-center gap-3">
                <a
                  href={waLink(WA.puja(p.name.en))}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`puja-enquire-${p.id}`}
                  className="inline-flex items-center gap-1 font-cinzel text-[10px] tracking-widest uppercase text-gold hover:text-wine transition-colors"
                >
                  <WhatsappIcon className="w-3 h-3" /> {t(S.enquireWa)}
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
